import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  celocal_id: [],
  endereco: '',
  tipo: [],
  posicao: '',
  x: '',
  y: '',
  picking: null,
  ativo: null,
  disponivel: null,
};

export const EnderecoContext = createContext();

export const EnderecoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [endereco, setEndereco] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getEndereco = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: endereco?.filter,
        page: endereco?.page,
        size: endereco?.size,
        order: endereco?.order,
        ...payload,
      });
      setEndereco((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <EnderecoContext.Provider
      value={{
        getLoading,
        endereco,
        getEndereco,
      }}
    >
      {children}
    </EnderecoContext.Provider>
  );
};
